import React, { useState, useEffect } from 'react';
import './personaldetail.css';
import userPlaceholder from '../../assets/images/My Selfie Character (head animation).jpeg';
import { MdOutlineCurrencyRupee } from 'react-icons/md';
import Dropdown from '../dropdown/Dropdown';
import axios from 'axios';
import API_URL from '../../utility/api';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../context/AdharDataContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PersonalDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData, setUserData } = useData();
  const [occupationOptions, setOccupationOptions] = useState([]);
  const [selectedOccupation, setSelectedOccupation] = useState('');
  const [incomeSources, setIncomeSources] = useState([]);
  const [selectedIncome, setSelectedIncome] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [monthlyIncome, setMonthlyIncome] = useState('');
  const [fatherName, setFatherName] = useState('');
  const [maidanName, setMaidanName] = useState('');
  const [error, setError] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    const storedResponseData = sessionStorage.getItem('responseData');
    if (storedResponseData) {
      const parsedResponseData = JSON.parse(storedResponseData);
      setUserData(parsedResponseData);
    }
  }, [setUserData]);

  useEffect(() => {
    const fetchOccupations = async () => {
      try {
        const response = await axios.get(API_URL + '/MasterData/GetOccupationTypeList?langkey=en');
        setOccupationOptions(response.data);
      } catch (error) {
        console.error('Error fetching occupation options:', error);
        toast.error('Failed to load occupation options');
      }
    };

    const fetchIncomeSources = async () => {
      try {
        const response = await axios.get(API_URL + '/MasterData/GetIncomeSourceType?langkey=en');
        setIncomeSources(response.data);
      } catch (error) {
        console.error('Error fetching income sources:', error);
        toast.error('Failed to load income sources');
      }
    };

    fetchOccupations();
    fetchIncomeSources();
  }, []);

  useEffect(() => {
    const isFormValid =
      selectedOccupation &&
      selectedIncome &&
      maritalStatus &&
      monthlyIncome &&
      fatherName &&
      maidanName;

    setButtonDisabled(!isFormValid);
  }, [selectedOccupation, selectedIncome, maritalStatus, monthlyIncome, fatherName, maidanName]);

  const handleMaritalStatusChange = (status) => {
    setMaritalStatus(status);
  };

  const handleMonthlyIncomeChange = (e) => {
    const regex = /^[0-9,]*$/;
    if (regex.test(e.target.value) || e.target.value === '') {
      const sanitizedValue = e.target.value.replace(/,/g, '');
      const formattedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      setMonthlyIncome(formattedValue);
    }
  };

  const handleFatherNameChange = (e) => {
    const newValue = e.target.value;
    if (newValue === '' || /^[a-zA-Z\s]*$/.test(newValue)) {
      setFatherName(newValue);
    }
  };

  const handleMaidanNameChange = (e) => {
    const newValue = e.target.value;
    if (newValue === '' || /^[a-zA-Z\s]*$/.test(newValue)) {
      setMaidanName(newValue);
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted');
  };

  const userDataExists = userData && Object.keys(userData).length > 0;
  if (!userDataExists) {
    console.error('userData is null or empty');
    toast.error('User data is missing. Please complete the previous steps.');
    navigate('/welcome'); // Redirect to previous step
    return null;
  }

  const maritalStatusOptions = ['Single', 'Married', 'Divorced', 'Widowed'];
  const maritalStatusValue = maritalStatusOptions.indexOf(maritalStatus) + 1;

  const handlebutton = async (e) => {
    e.preventDefault();

    const payload = {
      customerId: userData.customerId,
      firstName: userData.firstName,
      lastName: userData.lastName,
      dateOfBirth: userData.dateOfBirth,
      phoneNumber: userData.phoneNumber,
      panNumber: userData.panNumber,
      aadharNumber: userData.aadharNumber,
      gender: userData.gender,
      occupation: selectedOccupation.value,
      incomeSource: selectedIncome.value,
      monthlyIncome: parseInt(monthlyIncome.replace(/,/g, ''), 10),
      maritalStatus: maritalStatusValue,
      fatherName: fatherName,
      motherName: maidanName,
      panCardImage: null,
      profileImage: userData.profileImage,
      signatureImage: null,
      isVideoKycDone: false,
      active: true,
      deleted: false,
    };

    console.log('Payload sent to API:', payload); // Debug payload

    try {
      const response = await axios.post(API_URL + '/Customer/UpdateCustomer', payload);
      console.log('Form submitted successfully:', response.data);
      toast.success('Personal details updated successfully');
      navigate('/address');
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(
        error.response?.data?.message || error.response?.data || 'Failed to update personal details'
      );
      setError('Error submitting form');
    }
  };

   const getGenderLabel = (genderValue) => {
   switch (genderValue) {
    case 0:
      return 'None';
    case 1:
      return 'Male';
    case 2:
      return 'Female';
    case 3:
      return 'Other';
    default:
      return 0;
  }
};

  const dateString = userData && userData.dateOfBirth;
  const date = dateString ? new Date(dateString) : null;
  const formattedDate = date ? `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}` : '';
  const firstName = userData?.firstName || '';
  const lastName = userData?.lastName || '';
  const genderLabel = getGenderLabel(userData.gender);

  return (
    <div className="pd-container">
      <div className="pd-holder">
        <div className="user-pd">
          <img
            src={userData.profileImage ? `data:image/jpeg;base64,${userData.profileImage}` : userPlaceholder}
            alt="user profile"
          />
          <h3>{firstName} {lastName}</h3>
          <p>DOB: {formattedDate}</p>
          <p>Gender: {genderLabel}</p>
        </div>
        <div className="pd-form">
          <form onSubmit={handleSubmit}>
            <Dropdown
              title={t('Select Occupation')}
              options={occupationOptions.map((option) => ({
                label: option.name,
                value: option.occupationId?.toString() || '',
              }))}
              selectedOption={selectedOccupation}
              onSelect={setSelectedOccupation}
            />

            <Dropdown
              title={t('Select Income Source')}
              options={incomeSources.map((source) => ({
                label: source.incomeSourceName,
                value: source.incomeSourceId?.toString() || '',
              }))}
              selectedOption={selectedIncome}
              onSelect={setSelectedIncome}
            />

            <div className="form-field">
              <div className="input-field">
                <input
                  type="text"
                  id="monthlyIncome"
                  value={monthlyIncome}
                  placeholder={t('monthlyIncome')}
                  onChange={handleMonthlyIncomeChange}
                  maxLength={15}
                />
                <MdOutlineCurrencyRupee />
              </div>
            </div>

            <Dropdown
              title={t('Select Marital Status')}
              options={maritalStatusOptions.map((status) => ({ label: status, value: status }))}
              selectedOption={maritalStatus}
              onSelect={handleMaritalStatusChange}
            />

            <div className="form-field">
              <div className="input-field">
                <input
                  type="text"
                  id="fathername"
                  value={fatherName}
                  placeholder={t('fatherName')}
                  onChange={handleFatherNameChange}
                />
              </div>
            </div>

            <div className="form-field">
              <div className="input-field">
                <input
                  type="text"
                  id="maidanname"
                  value={maidanName}
                  placeholder={t('motherMaidenName')}
                  onChange={handleMaidanNameChange}
                />
              </div>
            </div>

            {error && <p className="error-message">{error}</p>}

            <div className="form-field">
              <button onClick={handlebutton} disabled={buttonDisabled}>
                {t('proceed')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PersonalDetail;